module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.e054fd25.jpg";